/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import api from '@/api/api' // 导入api接口
import store from "@/store/store";
import {
  router
} from '@/router/index'
// import 'lib-flexible/flexible'
import './assets/style/reset.less'
import './assets/font/iconfont.css'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css';
import dict from "@/utils/dict";
import {
  List,
  Dialog,
  Cell,
  NavBar,
  Toast,
  Divider,
  Field,
  CellGroup,
  Picker,
  Icon,
  Tab,
  Tabs,
  Loading,
  RadioGroup,
  Radio,
  ImagePreview,
  Tag,
  Card,
  Popup,
  CheckboxGroup,
  Checkbox,
  Button,
  Search,
  Switch,
  Swipe,
  SwipeItem,
  DatetimePicker,
  Step,
  Steps,
  Col,
  Row,
  Rate,
  Skeleton,
  PullRefresh,
  ActionSheet,
  Image,
  CountDown,    
  Progress,
  Circle, 
  Sticky, 
  Overlay 
} from 'vant'

Vue.use(Dialog).use(List).use(Field).use(CellGroup).use(Icon).use(Tab).use(Card).use(RadioGroup).use(Radio).use(ImagePreview).use(Button).use(Switch).use(DatetimePicker)
  .use(Cell).use(NavBar).use(Toast).use(Divider).use(Tabs).use(Loading).use(Tag).use(Picker).use(Popup).use(CheckboxGroup).use(Checkbox).use(Search).use(Swipe).use(SwipeItem)
  .use(Step).use(Steps).use(Col).use(Row).use(Skeleton).use(PullRefresh).use(Rate).use(ActionSheet).use(Image).use(CountDown).use(Progress).use(Circle).use(Sticky).use(Overlay)
Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.use(dict);
//在type为number下，只能输入正数及小数 包含小数点
Vue.directive("enterIntNumber", {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      let charcode = typeof e.charCode == "number" ? e.charCode : e.keyCode;
      let re = /[^-]/;
      if (!re.test(String.fromCharCode(charcode))) {
        e.preventDefault();
        e.returnValue = false;
      }
    });
  }
});
let vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
export default vue